import type { ProductConfig } from '#types/config/components/product'

export default {
  quickshopType: 'quickshop'
} satisfies ProductConfig['shopTheLook']
